// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel, residentsModel } from '@/firebase/firebase-config'
import { residentsUsersModel } from '@/firebase/residents-firebase-config'
import moment from 'moment';

// Import the events
import { GetUser } from '@/events/nestd-residents/GetUser'

export const UpdateLease = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GetUser

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        edit_lease_error: false,
        edit_lease_processing: false,
        edit_lease_updated: false,
        edit_lease_property_resident_updated: false,
        edit_lease_resident_updated: false,
        edit_lease_unit_updated: false,
        edit_lease_resident_user_updated: false

    }),

    /*
    **  Watch em'
    */

    watch: {

        edit_lease_error: {

            immediate: true, // Load on created
            handler(edit_lease_error) {

                /*
                **  Handle the error
                **  @method: @here
                */

                if (edit_lease_error) this.handleEditLeaseError();

            }

        },

        edit_lease_updated: {

            immediate: true, // Load on created
            handler(edit_lease_updated) {

                if (!this.edit_lease_error && edit_lease_updated && this.status.value == 'active') {
                    
                    /*
                    **  Update the property resident
                    **  @method: @here
                    */

                    this.editLeaseUpdatePropertyResident();

                } else if (!this.edit_lease_error && edit_lease_updated) {

                    /*
                    **  Skip ahead and complete the event
                    **  @prop: @here
                    */

                    this.edit_lease_resident_user_updated = true;

                }

            }

        },

        edit_lease_property_resident_updated: {

            immediate: true, // Load on created
            handler(edit_lease_property_resident_updated) {

                /*
                **  Update the resident
                **  @method: @here
                */

                if (!this.edit_lease_error && edit_lease_property_resident_updated && this.status.value == 'active') this.editLeaseUpdateResident();

            }

        },

        edit_lease_resident_updated: {

            immediate: true, // Load on created
            handler(edit_lease_resident_updated) {

                /*
                **  Update the unit
                **  @method: @here
                */

                if (!this.edit_lease_error && edit_lease_resident_updated && this.status.value == 'active') this.editLeaseUpdateUnit();

            }

        },

        edit_lease_unit_updated: {

            immediate: true, // Load on created
            handler(edit_lease_unit_updated) {

                /*
                **  Update the resident site user
                **  @method: @here
                */

                if (!this.edit_lease_error && edit_lease_unit_updated && this.status.value == 'active' && this.residents_user) this.editLeaseUpdateResidentSiteUser();

            }

        },

        edit_lease_resident_user_updated: {

            immediate: true, // Load on created
            handler(edit_lease_resident_user_updated) {

                /*
                **  Update the resident site user
                **  @method: @here
                */

                if (!this.edit_lease_error && edit_lease_resident_user_updated) this.completeUpdateLeaseEvent();

            }

        }

    },

    /*
	**  Methods
    */
    
    methods: {

        updateLeaseHandler: function() {

            try {

                /*
                **  If processing, return
                **  @prop: @here
                */

                if (this.edit_lease_processing) return;

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_lease_processing = true;

                /*
                **  Show the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.showSpinner();

                /*
                **  Update the lease
                **  @method: @here
                */

                this.updateLeaseDocument();

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Update the Lease',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'OVFNv9oZYKHRWb5jmI1c',
                    error: e
                });

            }

        },

        handleEditLeaseError: function() {

            try {

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_lease_processing = false;
    
                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw error message
                **  @service: SweetAlert2
                */

                this.$swal('Uh Oh!', 'We ran into some problems while trying to update the lease.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Handle an Error When Updating a Lease.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 's3FCE4G8DUfA0dUAG3fM',
                    error: e
                });

            }

        },

        updateLeaseDocument: function () {

            try {

                /*
                **  Create the lease doc
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).update({

                    'attributes.details.start_date': moment(this.start_date.value).unix(),
                    'attributes.details.end_date': moment(this.end_date.value).unix(),
                    'attributes.renewal.notice_date': moment(this.notice_date.value).unix(),
                    'attributes.renewal.send_notice': this.send_notice.value,
                    'links.documents': this.documents.value,
                    'type': this.lease_type.value,
                    'attributes.status': this.status.value,
                    'meta.updated_at': moment().unix()

                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update the Lease Document When Updating a Lease.',
                        errorType: 'Application',
                        section: 'Update Lease',
                        uid: 'DXWNwIWoOkxDWaOhJDEb',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.edit_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update the Lease Document When Updating a Lease.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'XJ5e9fqlhJihvM04f9CN',
                    error: e
                });

            }

        },

        editLeaseUpdatePropertyResident: function() {

            try {

                /*
                **  Update the property resident doc
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('residents').doc(this.resident.id).update({

                    'relationships.lease': this.lease.id,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_property_resident_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update the Property Resident Document When Updating a Lease.',
                        errorType: 'Application',
                        section: 'Edit Lease',
                        uid: 'OLggw0IWx2bVjYx6mo0H',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.edit_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update the Property Resident When Updating a Lease.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'KIWdfptgv6X3PxvRFbeR',
                    error: e
                });

            }

        },

        editLeaseUpdateResident: function() {

            try {

                /*
                **  Update the resident doc
                **  @service: @Firebase/Firestore
                */

                residentsModel.doc(this.resident.id).update({

                    'relationships.lease': this.lease.id,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_resident_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update the Resident Document When Updating a Lease.',
                        errorType: 'Application',
                        section: 'Edit Lease',
                        uid: 'VjVD4zrORyH1UBrn1Bz1',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.edit_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update the Resident When Updating a Lease.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'KCS6mtp2usaNAqaMbNNz',
                    error: e
                });

            }

        },

        editLeaseUpdateUnit: function() {

            try {

                /*
                **  Update the resident doc
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('units').doc(this.lease.relationships.unit).update({

                    'relationships.lease': this.lease.id,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_unit_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update the Unit Document When Updating a Lease.',
                        errorType: 'Application',
                        section: 'Edit Lease',
                        uid: 'ItZZ4V3XL3MTIIJKZNvO',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.edit_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update the Unit When Updating a Lease.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'GfVnHQh1GZ7Qtxg16UVS',
                    error: e
                });

            }

        },

        editLeaseUpdateResidentSiteUser: function() {

            try {

                /*
                **  Update the resident
                **  @service: @Firebase/Firestore
                */

                residentsUsersModel.doc(this.residents_user.id).update({
                    'relationships.lease': this.lease.id,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_resident_user_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_lease_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update a Nestd Resident User Document in Firestore.',
                        errorType: 'Application',
                        section: 'Edit Lease',
                        uid: 'EGSpQdJ0yKkC2koNZHiu',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.edit_lease_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update a Nestd Resident User Document in Firestore.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'uk2Svmuwz30mj9N85Vxf',
                    error: e
                });

            }

        },

        completeUpdateLeaseEvent: function() {

            try {

                /*
                **  Reset the validation props
                **  @prop: Components/Property/Leases/AddLeaseMenu
                */

                this.resetValidationProps();

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_lease_processing = false;

                /*
                **  Reset the form props
                **  @prop: @here
                */

                this.edit_lease_error = false;
                this.edit_lease_processing = false;
                this.edit_lease_updated = false;
                this.edit_lease_property_resident_updated = false;
                this.edit_lease_resident_updated = false;
                this.edit_lease_unit_updated = false;
                this.edit_lease_resident_user_updated = false;

                /*
                **  Close the menu
                **  @method: Components/Property/Leases/EditLeaseMenu
                */

                this.closeEditLeaseMenu();

                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw success message
                **  @service: SweetAlert2
                */

                this.$swal('Success!', 'Your lease has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Complete the Lease Update Event.',
                    errorType: 'Application',
                    section: 'Edit Lease',
                    uid: 'ckJrf1TAHMjdD8wdvMuf',
                    error: e
                });

            }

        },

    }

}